import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { ProgramDispensingHistoryUploadPage } from './program-dispensing-history-upload';

@NgModule({
  declarations: [
    ProgramDispensingHistoryUploadPage,
  ],
  imports: [
    IonicPageModule.forChild(ProgramDispensingHistoryUploadPage),
  ],
})
export class ProgramDispensingHistoryUploadPageModule {}



// WEBPACK FOOTER //
// ./src/pages/program-dispensing-history-upload/program-dispensing-history-upload.module.ts